import { useLayout } from "@/contexts/LayoutContext";

/**
 * The admin top bar's height, which the rail's header matches so the two form
 * one strip across the screen (Jira NAV-28), and which anything else sticky in
 * an admin page has to sit below — the bar is pinned over the top of the
 * window, beneath any banners (`useLayout().bannerStackHeightPx`).
 *
 * Its own module because both halves of the strip read it and `AdminLayout`
 * already imports `Sidebar`.
 */
export const ADMIN_HEADER_HEIGHT_PX = 64;

/**
 * Where the admin chrome is pinned (Jira NAV-222): `banners` is the height of
 * the banners the root pins above an admin area, which is where the rail and
 * the top bar stick; `belowTopBar` is where anything sticky inside a page
 * sticks, under both. One hook so the three readers cannot disagree.
 */
export function useAdminStickyTop(): { banners: number; belowTopBar: number } {
  const { bannerStackHeightPx } = useLayout();
  return {
    banners: bannerStackHeightPx,
    belowTopBar: bannerStackHeightPx + ADMIN_HEADER_HEIGHT_PX,
  };
}
